module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/the_way-6c3bb4ac5330c5609abb161962af5e13.svg";